import { Box, ColorOptions, convertHexToRGBA, Icon, IconOptions, ModBox, Spacer, Text } from '@jfs/ui-new'
import { SvgImage } from '../../comps/SvgImage'
import { Colors, dateFormatter, DateFormatTypes, extractFirstLetterFromName } from '../../util/util'

interface headerInterfacce {
  amount: number
  txnStatus: string
  name?: string
  tab?: string
  timestamp: string
}

const convertTime = (timestamp) => {
  const dateAndTime = timestamp?.split(',')
  const date = dateAndTime?.[0]?.trim()
  const time = dateAndTime?.[1]?.trim()
  const formattedDate = dateFormatter(date, DateFormatTypes.DD_MMM_YYYY)
  return `${formattedDate}, ${time}`
}
const getIcon = (txnStatus: string, name: string, tab: string) => {
  if (txnStatus?.match(/SUCCESS/i)) {
    return {
      iconId: 'SUCCESSFUL_FILLED',
      status: `${tab === 'refunded' ? 'Refunded to' : 'Received from'} ${name}`,
      color: '#00B259',
    }
  }
  if ((txnStatus?.match(/FAILED/i) || txnStatus?.match(/FAILURE/i)) && !txnStatus?.match(/REFUND FAILED/i)) {
    return {
      id: 'error',
      status: 'Payment Failed',
    }
  }
  if (txnStatus?.match(/REFUND ACCEPTED/i)) {
    return {
      iconId: 'SUCCESSFUL_FILLED',
      status: 'Refund Successful',
      color: '#00B259',
    }
  }
  if (txnStatus?.match(/REFUND FAILED/i)) {
    return {
      id: 'error',
      status: 'Refund Failed',
    }
  }
  if (txnStatus?.match(/INPROCESS/i)) {
    return {
      iconId: 'TIMER' as IconOptions,
      status: 'Payment Processing',
      color: '#FA7D19',
    }
  }
  return {
    iconId: 'INFO',
    status: 'Payment Pending',
    color: '#FA7D19',
  }
}

export const Header = ({ amount, txnStatus, name = '', timestamp, tab }: headerInterfacce) => {
  const icon = getIcon(txnStatus, name, tab)
  const isSuccess = txnStatus?.toUpperCase() === 'SUCCESS' || txnStatus?.toUpperCase()?.includes('REFUND ACCEPTED')
  return (
    <Box>
      <Box
        justify="center"
        align="center"
        w={56}
        h={56}
        bg={icon?.color ? (convertHexToRGBA(icon.color, 20) as ColorOptions) : 'WHITE'}
        borderRadius={28}>
        <Text
          title={extractFirstLetterFromName(name)}
          fontFamily={'JioType-Bold'}
          fontSize={18}
          lineHeight={24}
          letterSpacing={-0.09}
          hide={!!icon.id}
        />
        <ModBox show={!!icon.id}>
          <SvgImage imageName={icon.id} />
        </ModBox>
        <ModBox p={1} show={!!icon?.iconId} position={'absolute'} right={-4} bottom={-4} bg={'WHITE'} borderRadius={10}>
          <Icon id={icon.iconId as IconOptions} size={20} color={icon.color as ColorOptions} />
        </ModBox>
      </Box>
      <Spacer size={16} direction={'vertical'} />
      <Text
        title={`${'\u20B9'}${amount}`}
        fontFamily={'JioType-Black'}
        fontSize={32}
        lineHeight={36}
        letterSpacing={-0.09}
        color={Colors.BLACK_14 as ColorOptions}
      />
      <Spacer size={8} direction={'vertical'} />
      <Text
        title={icon.status}
        fontFamily={'JioType-Bold'}
        fontSize={16}
        lineHeight={24}
        letterSpacing={-0.09}
        color={Colors.BLACK_14 as ColorOptions}
      />
      <Spacer size={3} direction={'vertical'} />
      <Text
        title={convertTime(timestamp)}
        fontFamily={'JioType-Medium'}
        fontSize={14}
        lineHeight={20}
        letterSpacing={-0.09}
        color={convertHexToRGBA('#000000', 65) as ColorOptions}
      />

      <Spacer size={24} direction={'vertical'} />
    </Box>
  )
}
